





























































import { Component, Vue, Watch } from 'vue-property-decorator';
import BreadcrumbInterface from '@/_shared/components/layout/breadcrumb.interface';
import HoldingTankService from '@/_shared/services/holding-tank.service';
import Rep from '@/_shared/entities/rep/rep.entity';
import UserInHoldingTankTableFormatted from '@/monitor/interfaces/user-in-holding-tank-table-formatted.interface';
import UserInHoldingTank from '@/_shared/interfaces/user-in-holding-tank.interface';
import Breadcrumb from '@/_shared/components/layout/breadcrumb.component.vue';
import VCard from '@/_shared/components/v-card/v-card.component.vue';
import RepPhotoComponent from '@/_shared/components/rep/user-photo.component.vue';
import HoldingTankCard from '@/monitor/components/holding-tank-card.component.vue';
import HoldingTankMobileSortComponent from '@/monitor/components/holding-tank-mobile-sort.vue';
import HoldingTankSortTypes from '@/monitor/enums/holding-tank-sort.enum';

@Component({
  components: {
    Breadcrumb,
    VCard,
    RepPhotoComponent,
    HoldingTankCard,
    HoldingTankMobileSortComponent,
  },
})
export default class HoldingTankReportPage extends Vue {
  breadcrumb: BreadcrumbInterface[] = [];
  private businessPartnes: UserInHoldingTankTableFormatted[] = []
  private sortDesc = null;
  private sortBy = null;
  private hasData = false;
  private hasFinishedLoading = false;
  private MOBILE_BREAKPOINT = 1024
  isMobile = window.screen.width <= this.MOBILE_BREAKPOINT;

  @Watch('sortDesc')
  onSortThirdClick(value: boolean) {
    if (!value) this.sortBy = null;
  }

  async created() {
    window.addEventListener('resize', this.onResize, { passive: true });
    this.breadcrumb = this.$route.meta.breadcrumb;
    this.hasFinishedLoading = false;
    this.businessPartnes = await this.getBusinessPartnes();
    this.hasFinishedLoading = true;
  }

  async getBusinessPartnes(): Promise<UserInHoldingTankTableFormatted[]> {
    try {
      this.$store.dispatch('showLoading');
      const data = await HoldingTankService.getHoldingTank();
      this.$store.dispatch('hideLoading');
      const users = this.formatData(data);
      this.hasData = data.length > 0;
      return users;
    } catch (e) {
      this.hasData = false;
      return [];
    }
  }

  onResize() {
    this.isMobile = window.screen.width <= this.MOBILE_BREAKPOINT;
  }

  sortMobile(data: any) {
    switch (data) {
      case HoldingTankSortTypes.NAME_UPWARD:
        this.sortByName(false);
        break;
      case HoldingTankSortTypes.NAME_DOWNWARD:
        this.sortByName(true);
        break;
      case HoldingTankSortTypes.SPONSOR_UPWARD:
        this.sortBySponsor(false);
        break;
      case HoldingTankSortTypes.SPONSOR_DOWNWARD:
        this.sortBySponsor(true);
        break;
      case HoldingTankSortTypes.VOLUME_UPWARD:
        this.sortByVolume(false);
        break;
      case HoldingTankSortTypes.VOLUME_DOWNWARD:
        this.sortByVolume(true);
        break;
      default:
    }
  }

  sortByName(reverse?: boolean) {
    if (!reverse) {
      return this.businessPartnes.sort(
        (a, b) => a.user.enrolleeName.localeCompare(b.user.enrolleeName),
      );
    }
    return this.businessPartnes.sort(
      (a, b) => b.user.enrolleeName.localeCompare(a.user.enrolleeName),
    );
  }

  sortBySponsor(reverse?: boolean) {
    if (!reverse) {
      return this.businessPartnes.sort(
        (a, b) => a.sponsorName.localeCompare(b.sponsorName),
      );
    }
    return this.businessPartnes.sort(
      (a, b) => b.sponsorName.localeCompare(a.sponsorName),
    );
  }

  sortByVolume(reverse?: boolean) {
    if (!reverse) {
      return this.businessPartnes.sort(
        (a, b) => a.volume - b.volume,
      );
    }
    return this.businessPartnes.sort(
      (a, b) => b.volume - a.volume,
    );
  }
  formatData(usersInHoldingTank: UserInHoldingTank[]): UserInHoldingTankTableFormatted[] {
    return usersInHoldingTank.map((user) => ({
      user: {
        enrolleeDid: user.enrolleeDid,
        enrolleeName: user.enrolleeName,
        enrolleePicture: user.enrolleePicture,
      },
      sponsorName: user.sponsorName,
      volume: user.volume,
      sponsorDid: user.sponsorDid,
    }));
  }

  get rep(): Rep {
    return this.$store.state.RepStore.rep;
  }

  bodyRowClass(): string {
    return 'downline-report-table__custom-row';
  }

  formatValue(value: number) {
    return value.toLocaleString();
  }

  get bodyCellClass(): string {
    return 'holding-tank-report-table__body-cell blue text-sm wide-column left';
  }

  get bodyUserCellClass(): string {
    return 'holding-tank-report-table__user-body-cell blue text-sm wide-column';
  }

  get headerCellClass(): string {
    return 'holding-tank-report-table__header-cell wide-column left';
  }

  get headerUserCellClass(): string {
    return 'holding-tank-report-table__user-header-cell wide-column';
  }

  get headerVolumeCellClass(): string {
    return 'holding-tank-report-table__header-cell right';
  }

  get bodyVolumeCellClass(): string {
    return 'holding-tank-report-table__body-cell right';
  }

  get fields() {
    return [
      { key: 'user', label: this.$t('YOUR_HOLDING_TANK.ENROLEE'), tdClass: this.bodyUserCellClass, thClass: this.headerUserCellClass, sortable: true },
      { key: 'sponsorName', label: this.$t('YOUR_HOLDING_TANK.SPONSOR'), tdClass: this.bodyCellClass, thClass: this.headerCellClass, sortable: true },
      { key: 'volume', label: this.$t('YOUR_HOLDING_TANK.VOLUME'), tdClass: this.bodyVolumeCellClass, thClass: this.headerVolumeCellClass, sortable: true },
    ];
  }

  sort(a: UserInHoldingTankTableFormatted, b: UserInHoldingTankTableFormatted,
    key: string): number {
    switch (key) {
      case ('user'): return a.user.enrolleeName.localeCompare(b.user.enrolleeName);
      case ('sponsorName'): return a.sponsorName.localeCompare(b.sponsorName);
      case ('volume'): return a.volume - b.volume;
      default:
        return a.user.enrolleeName.localeCompare(b.user.enrolleeName);
    }
  }

  private openVCard(repDID: string): void {
    (this.$refs.vCard as VCard).show(repDID);
  }

  totalValue() {
    return this.formatValue(this.businessPartnes.reduce((acc, item) => acc + item.volume, 0));
  }
}
